/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'

import useBillingDetails from '@modules/billing-lib/billingDetails/useBillingDetails'
import { isInactive, isPrepaidConsumptionCustomer } from '@modules/billing-lib/billingDetails/utils'

import InactiveOverview from './InactiveOverview'
import GenericOverview from './GenericOverview'
import PrepaidConsumptionOverview from './PrepaidConsumptionOverview'

const PlanOverviewPanel = ({ organizationId }) => {
  const billingDetails = useBillingDetails()

  // sanity
  if (!billingDetails.data) {
    return null
  }

  if (isPrepaidConsumptionCustomer(billingDetails.data)) {
    return <PrepaidConsumptionOverview organizationId={organizationId} />
  }

  if (isInactive(billingDetails.data)) {
    return <InactiveOverview />
  }

  return <GenericOverview />
}

export default PlanOverviewPanel
